import { render, staticRenderFns } from "./RegisterAnnualMember.vue?vue&type=template&id=72072b7e&"
import script from "./RegisterAnnualMember.vue?vue&type=script&lang=js&"
export * from "./RegisterAnnualMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports